import React from "react";
import "./Mywork.css"

const MyWork = () => {
    return (
        <div className="MyWork" id="projects">
            <div className="work">
                <h1>My <br/>Work </h1>
                <div className="describework">
                    <p>Contributed in some of the biggest technological events in my college.
                        I believe in creating a beautiful culmination of different technologies through a conjuncture of 
                        efficient framework. I strive for creation and innovation. </p>
                </div>
            </div>
            <div className="project">
              <video width="600" height="400" autoPlay loop muted playsInline src="/animation.webm" type="video/webm"></video>
            </div>
        </div>
    );
};

export default MyWork;
